import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_STATUSTEMPLATES, res.data)
  })
)

export const show = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_STATUSTEMPLATE, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.saveStatusTemplate(obj).then(res => {
    commit(types.SET_STATUSTEMPLATE, res.data.data)
    return res
  })
}

export const deleteStatusTemplate = async ({ commit }, obj) => {
  await services.deleteStatusTemplate(obj).then(res => {
    return res
  })
}

export const changeStatus = async ({ commit }, obj) => {
  await services.changeStatus(obj).then(res => {
    return res
  })
}
